<template>
  <div v-if="user">

    <div class="user-options-wrap">
      <v-header>
        <div class="flex flex-end">
          <v-dropdown :data="userOptions" trigger="click" @item-click="userAction">
            <a href="javascript:void(0)" class="ant-dropdown-link ant-dropdown-trigger">
            Hello! {{user.displayName || user.email}} <v-icon type="down"></v-icon>
            </a>
          </v-dropdown>
        </div>
      </v-header>
    </div>

    <div class="content">

      <div>
        <div class="salutation">
          <h2>Welcome! {{user.displayName || user.email}}</h2>
          <div v-if="!(user.personal_details && user.company_details)">
            Please provide below details to get access to the application
          </div>
        </div>

        <v-tabs :active-tab-key="this.user.personal_details ? 'companyDetails' : 'personalDetails'"
         v-if="!(user.personal_details && user.company_details)">
          <v-tab-pane tab-key="personalDetails" tab="Personal Details">
            <v-form direction="horizontal" :model="pdForm" :rules="pdRules" ref="pdformRef">
              <v-form-item label="First Name"
                prop="first_name">
                <v-input size="large" v-model="pdForm.first_name" placeholder="First Name"></v-input>
              </v-form-item>
              <v-form-item label="Last Name"
                prop="last_name">
                <v-input size="large" v-model="pdForm.last_name" placeholder="Last Name"></v-input>
              </v-form-item>
              <v-form-item label="Personal Email ID"
                prop="personal_email">
                <v-input size="large" v-model="pdForm.personal_email" placeholder="Personal Email ID"></v-input>
              </v-form-item>
              <v-form-item label="Business Email ID"
                prop="business_email">
                <v-input size="large" v-model="pdForm.business_email" placeholder="Business Email ID"></v-input>
              </v-form-item>
              <v-form-item label="Phone Number"
                prop="phone_number">
                <v-input size="large" v-model="pdForm.phone_number" placeholder="CountryCode-Phone Number"></v-input>
              </v-form-item>
              <v-form-item :wrapper-col="{offset:6, span: 14 }">
                <v-button type="primary" style="margin-right:10px" @click.prevent="submitForm('pdformRef')">Submit</v-button>
                <v-button type="ghost" @click.prevent="resetForm('pdformRef')">Reset</v-button>
              </v-form-item>
            </v-form>
          </v-tab-pane>

          <v-tab-pane tab-key="companyDetails" tab="Company Details">
            <v-form direction="horizontal" :model="cdForm" :rules="cdRules" ref="cdformRef">

              <div class="company-details-wrap">
                <div style="width:49%;">
                  <v-form-item label="Company Name"
                    prop="company_name">
                    <v-input size="large" v-model="cdForm.company_name" placeholder="Company Name"></v-input>
                  </v-form-item>
                  <v-form-item label="Phone Number"
                    prop="phone_number">
                    <v-input size="large" v-model="cdForm.phone_number" placeholder="CountryCode-Phone Number"></v-input>
                  </v-form-item>
                  <v-form-item label="Website"
                    prop="website">
                    <v-input size="large" v-model="cdForm.website" placeholder="Website"></v-input>
                  </v-form-item>
                  <v-form-item label="Branch offices"
                    prop="branch_office_locations">
                    <v-input size="large" v-model="cdForm.branch_office_locations" placeholder="Branch Office locations comma(,) separated"></v-input>
                  </v-form-item>
                  <v-form-item label="Collaboration"
                    prop="collaborate_study_abroad_agency">
                    <v-input size="large" v-model="cdForm.collaborate_study_abroad_agency"
                    placeholder="Do you collaborate with any other Study Abroad agency?"></v-input>
                  </v-form-item>
                  <v-form-item label="Primary expertise"
                    prop="collaborate_study_abroad_agency">
                    <v-select search placeholder="Primary Country of expertise for study abroad" size="large"
                      v-model="cdForm.primary_country_expertise_study_abroad" :data="countriesOptions" :filter="filterDropDown"
                      @change="(val) => selectChange('cdForm', 'collaborate_study_abroad_agency', val)"
                      notFoundContent="No match found"></v-select>
                  </v-form-item>
                  <v-form-item label="Sent abroad last year"
                    prop="students_sent_abroad_last_year">
                    <v-input size="large" v-model="cdForm.students_sent_abroad_last_year"
                    placeholder="How many students your agency sent abroad in the last year?"></v-input>
                  </v-form-item>
                </div>
                <div style="width:49%;">
                  <v-form-item label="Street Address"
                    prop="street_address">
                    <v-input size="large" v-model="cdForm.street_address" placeholder="Street Address"></v-input>
                  </v-form-item>
                  <v-form-item label="City"
                    prop="city">
                    <v-input size="large" v-model="cdForm.city" placeholder="City"></v-input>
                  </v-form-item>
                  <v-form-item label="Country"
                    prop="country">
                    <v-select search placeholder="Country" size="large"
                      v-model="cdForm.country" :data="countriesOptions" :filter="filterDropDown"
                      @change="(val) => selectChange('cdForm', 'country', val)"
                      notFoundContent="No match found"></v-select>
                  </v-form-item>
                  <v-form-item label="Province / State"
                    prop="province">
                    <v-input size="large" v-model="cdForm.province" placeholder="Province / State"></v-input>
                  </v-form-item>
                  <v-form-item label="Postal / Zip Code"
                    prop="zip_code">
                    <v-input size="large" v-model="cdForm.zip_code" placeholder="Postal / Zip Code"></v-input>
                  </v-form-item>
                  <v-form-item label="Years of expertise(yrs)"
                    prop="years_of_expertise">
                    <v-input size="large" v-model="cdForm.years_of_expertise"
                    placeholder="How many years of expertise"></v-input>
                  </v-form-item>
                  <v-form-item label="Anticipate to send Canada"
                    prop="students_anticipate_send_canada_every_year">
                    <v-input size="large" v-model="cdForm.students_anticipate_send_canada_every_year"
                    placeholder="How many students do you anticipate to send to Canada every year?"></v-input>
                  </v-form-item>
                </div>
              </div>
              <v-form-item style="margin-top: 20px;display:flex;justify-content:center;">
                <v-button type="primary" style="margin-right:10px" @click.prevent="submitForm('cdformRef')">Submit</v-button>
                <v-button type="ghost" @click.prevent="resetForm('cdformRef')">Reset</v-button>
              </v-form-item>
            </v-form>
          </v-tab-pane>
        </v-tabs>
      </div>

      <div v-if="(user.personal_details && user.company_details)">
        <div v-if="user.status === 'Details Submitted'">
          Thank you for registering with CanEd. We will process your registration soon.
        </div>
        <div v-if="user.status === 'Authorized'">
          Your registration is accepted
        </div>
        <div v-if="user.status === 'Rejected'">
          Sorry, Your registration is not accepted. Kindly call to +1-999 for more information.
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import fb from '@/firebase'
import { mapGetters } from 'vuex'
import { validateString, validateEmail, validateSpaceString, validatePhoneNumber, validateNumber } from '../validations'
import countriesDetail from '../../assets/countries.json'

export default {
  name: 'RequireDetails',
  data () {
    return {
      userOptions: [
        {content: 'Logout'}
      ],
      countriesOptions: countriesDetail.map(x => ({label: x.name, value: x.name})),
      pdForm: {
        first_name: null,
        last_name: null,
        personal_email: null,
        business_email: null,
        phone_number: null
      },
      cdForm: {
        company_name: null,
        phone_number: null,
        website: null,
        street_address: null,
        country: null,
        city: null,
        province: null,
        zip_code: null,
        branch_office_locations: null,
        primary_country_expertise_study_abroad: null,
        years_of_expertise: null,
        students_sent_abroad_last_year: null,
        students_anticipate_send_canada_every_year: null,
        collaborate_study_abroad_agency: null
      },
      pdRules: {
        first_name: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateSpaceString
        }],
        last_name: [{
          validator: validateSpaceString
        }],
        personal_email: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateEmail
        }],
        business_email: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateEmail
        }],
        phone_number: [{
          required: true,
          message: '* Required'
        }, {
          validator: validatePhoneNumber
        }]
      },
      cdRules: {
        company_name: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateSpaceString
        }],
        phone_number: [{
          required: true,
          message: '* Required'
        }, {
          validator: validatePhoneNumber
        }],
        website: [{
          required: true,
          message: '* Required'
        }],
        street_address: [{
          required: true,
          message: '* Required'
        }],
        country: [{
          required: true,
          message: '* Required'
        }],
        city: [{
          required: true,
          message: '* Required'
        }],
        province: [{
          required: true,
          message: '* Required'
        }],
        zip_code: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateNumber
        }],
        primary_country_expertise_study_abroad: [{
          required: true,
          message: '* Required'
        }],
        years_of_expertise: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateNumber
        }],
        students_sent_abroad_last_year: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateNumber
        }],
        students_anticipate_send_canada_every_year: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateNumber
        }],
        collaborate_study_abroad_agency: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateSpaceString
        }],
        branch_office_locations: [{
          required: true,
          message: '* Required'
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
    user: {
      handler (val) {
        if (val && val.personal_details) {
          this.pdForm = {...this.pdForm, ...val.personal_details}
        }
        if (val && val.company_details) {
          this.cdForm = {...this.cdForm, ...val.company_details}
        }
      },
      immediate: true
    }
  },
  methods: {
    userAction (data) {
      if (data.content === 'Logout') {
        fb.logout()
        this.$router.push('/auth')
      }
    },
    submitForm (formName) {
      if (formName === 'pdformRef') {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$store.dispatch('setLoaderStatus', true)
            fb.updateUserDetails(this.user.uid, {personal_details: this.pdForm})
              .then(() => {
                this.$store.dispatch('setCurrentUser', {...this.user, ...{personal_details: this.pdForm}})
                this.$store.dispatch('setLoaderStatus', false)
              })
          } else {
            return false
          }
        })
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$store.dispatch('setLoaderStatus', true)
            fb.updateUserDetails(this.user.uid, {company_details: this.cdForm, status: 'Details Submitted'})
              .then(() => {
                this.$store.dispatch('setCurrentUser',
                  {...this.user, ...{company_details: this.cdForm, status: 'Details Submitted'}})
                this.$store.dispatch('setLoaderStatus', false)
              })
          } else {
            return false
          }
        })
      }
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    selectChange (form, key, val) {
      this[form][key] = val
    },
    filterDropDown (val, item) {
      const selected = val.toLowerCase()
      return item.label.toLowerCase().indexOf(selected) > -1
    }
  }
}
</script>

<style scoped>
.ant-layout-header {
  background: transparent;
  padding: 0;
  height: 34px;
  line-height: 34px;
}
.ant-dropdown {
  top: 34px;
}
.user-options-wrap {
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}
.content {
  width: 80%;
  margin: auto;
}
form {
  margin-top: 40px;
}
.salutation {
  margin-bottom: 40px;
}
.company-details-wrap {
   display: flex;
   justify-content: space-between;
   /* max-height: calc(47vh - 10px);
   overflow-y: auto; */
}
</style>



// WEBPACK FOOTER //
// src/views/Associate/RequireDetails.vue